// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"be3c55ad","188":"00c0d058","569":"58e173c9","857":"42257df1","950":"d5e307f5"}[chunkId] + ".chunk.js";
};